import React from "react";
import { Box } from "@chakra-ui/react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PageContainer } from "./PageContainer";

interface Props {
  children: React.ReactNode;
}

export const Layout = ({ children }: Props) => {
  return (
    <>
      <Header />
      <Box
        color="white"
        background="url('/images/bg.png'), linear-gradient(180deg, #1A1A1B 0%, #323233 47.92%, #464647 100%)"
        backgroundRepeat="repeat-x"
        backgroundSize="10% auto"
        backgroundBlendMode="overlay"
        backgroundPosition="bottom left"
      >
        <PageContainer
          background="url('/images/narcan_icon.png')"
          backgroundPosition={{ base: "center -140px", md: "center -120px" }}
          backgroundRepeat="no-repeat"
          pt={{ base: "140px", md: "180px" }}
          pb="16"
        >
          {children}
        </PageContainer>
      </Box>
      <Footer />
    </>
  );
};
